// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body[data-v-0467f3aa]{background-color:#f4f4f4;color:#5c5c5c}", ""]);
// Exports
module.exports = exports;
